module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "pull-right text-muted count"
  }, [_c('em', [_vm._v("n")]), _vm._v("\n      =" + _vm._s(_vm.totalRespondents) + "\n    ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), (_vm.profileCharts && Object.keys(_vm.profileCharts).length > 0) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((Math.ceil(Object.keys(_vm.profileCharts).length / _vm.itemsPerRow)), function(i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, _vm._l((Object.keys(_vm.profileCharts).sort().slice((i - 1) * _vm.itemsPerRow, i * _vm.itemsPerRow)), function(key) {
      return _c('div', {
        key: key,
        staticClass: "col-lg-3"
      }, [_c('h4', [_vm._v(_vm._s(_vm.capitalise(key)))]), _vm._v(" "), (false) ? _c('div', [_c('div', {
        staticClass: "gender-respondents"
      }, [_c('div', {
        staticClass: "gender-block"
      }, [_c('div', {
        on: {
          "click": function($event) {
            _vm.handleGenderClicked($event, 'Gender', _vm.genderItem('Male'))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-male",
        style: ({
          color: _vm.generateTitleColor('male', _vm.hueRange)
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "gender-percentage"
      }, [_vm._v(_vm._s(_vm.profileGender('Male')))])]), _vm._v(" "), _c('div', {
        staticClass: "gender-block"
      }, [_c('div', {
        on: {
          "click": function($event) {
            _vm.handleGenderClicked($event, 'Gender', _vm.genderItem('Female'))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-fw fa-female",
        style: ({
          color: _vm.generateTitleColor('female', _vm.hueRange)
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "gender-percentage"
      }, [_vm._v(_vm._s(_vm.profileGender('Female')))])])]), _vm._v(" "), _c('chart-legend', {
        attrs: {
          "data": [
            ['Male', _vm.profileGender('Male')],
            ['Female', _vm.profileGender('Female')]
          ],
          "colorCycle": [_vm.generateTitleColor('male', _vm.hueRange), _vm.generateTitleColor('female', _vm.hueRange)]
        }
      })], 1) : _vm._e(), _vm._v(" "), (true) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "155px"
        }
      }, [_c('pie-chart', {
        attrs: {
          "height": 155,
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.profileCharts[key]), _vm.hueRange),
          "data": _vm.totalDisplay(_vm.profileCharts[key]),
          "options": _vm.pieChartOptions
        },
        on: {
          "onClick": function($event) {
            return _vm.handleProfileClicked($event, key, _vm.profileCharts[key])
          }
        }
      })], 1), _vm._v(" "), _c('chart-legend', {
        attrs: {
          "data": _vm.totalDisplay(_vm.profileCharts[key]),
          "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.profileCharts[key]), _vm.hueRange),
          "isPercentage": _vm.selectedTotalDisplay === 'percentage'
        }
      })], 1) : _vm._e()])
    }), 0)
  }), 0) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('empty', [_vm._v("No respondents found.")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aedc9c7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/RespondentProfileChart.vue
// module id = 3380
// module chunks = 3